// extracted by mini-css-extract-plugin
export default {"subHeader":"style--subHeader--7c36c4","bolded":"style--bolded--cdf586"};